import validate from "/usr/src/app/content/n3-treatments-a5c20f37-acbb-4c73-b47d-c00d2aeed31d/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-treatments-a5c20f37-acbb-4c73-b47d-c00d2aeed31d/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}